import { getAdminUrl, getMergedHeaders, useReapitConnectSession } from '@reapitform/hooks'
import { AdminPdfTemplate } from '../types'

/**
 * Returns a function that opens a template's PDF. The pre-signed download URL is only populated on the
 * single-resource read, so this fetches that record then opens the URL in a new tab.
 */
export const usePdfTemplateDownload = (formReferenceID: string, versionReferenceID: string) => {
  const session = useReapitConnectSession()

  return async (templateReferenceID: string): Promise<void> => {
    const headers = await getMergedHeaders(session)
    if (!headers) throw new Error('Your session has expired — please sign in again.')

    const url = getAdminUrl(
      `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-templates/${templateReferenceID}`,
    )()
    const response = await fetch(url, { headers: headers as HeadersInit })
    if (!response.ok) throw new Error(`Failed to load download link (${response.status})`)

    const template = (await response.json()) as AdminPdfTemplate
    if (!template.downloadUrl) throw new Error('Download link is not available for this PDF template.')

    window.open(template.downloadUrl, '_blank', 'noopener')
  }
}
